import { detectIE } from "../../../Engine/utils";

let noSecondScroll = false;
const ieVersion = detectIE();
const perTick = ieVersion && ieVersion !== 9 ? 50 : 20;

function scrollInner(inner: HTMLElement, offset: number): boolean {
    if (offset < inner.scrollLeft) {
        inner.scrollLeft =
            // @ts-ignore Я не понял, зачем вызывать parseInt
            inner.scrollLeft - offset < perTick ? parseInt(offset, 10) : parseInt(inner.scrollLeft - perTick, 10);

        return inner.scrollLeft <= offset;
    }

    inner.scrollLeft =
        // @ts-ignore Я не понял, зачем вызывать parseInt
        offset - inner.scrollLeft < perTick ? parseInt(offset, 10) : parseInt(inner.scrollLeft + perTick, 10);

    return inner.scrollLeft >= offset;
}

function scrollInnerTo(inner: HTMLElement, offset: number): void {
    if (noSecondScroll) {
        return;
    }

    noSecondScroll = true;
    let oldScrollLeft = inner.scrollLeft;

    const iterationFunction = (nextIteration: () => void) => {
        const finishScroll = scrollInner(inner, offset);

        if (finishScroll || oldScrollLeft === inner.scrollLeft) {
            noSecondScroll = false;

            return;
        }

        oldScrollLeft = inner.scrollLeft;
        nextIteration();
    };

    if (ieVersion && ieVersion < 10) {
        const scrollFunctionOldIE = () => {
            iterationFunction(() => setTimeout(scrollFunctionOldIE, 10));
        };

        scrollFunctionOldIE();
    } else {
        const scrollFunction = () => {
            iterationFunction(() => requestAnimationFrame(scrollFunction));
        };

        requestAnimationFrame(scrollFunction);
    }
}

function getLeftStop(scrollOffset: number, stopPoints: number[], width?: number): number {
    if (width != undefined) {
        for (let i = stopPoints.length - 1; i > 0; i--) {
            if (scrollOffset - (stopPoints[i] ?? 0) > width + 5) {
                return stopPoints[i + 1] ?? 0;
            }
        }
    }

    return stopPoints[0] ?? 0;
}

function getRightStop(scrollOffset: number, stopPoints: number[], width?: number): number {
    if (width != undefined) {
        for (let i = 1; i < stopPoints.length; i++) {
            if ((stopPoints[i] ?? 0) - scrollOffset > width - 5) {
                return stopPoints[i - 1] ?? 0;
            }
        }
    }

    return stopPoints[stopPoints.length - 1] ?? 0;
}

export function scrollLeft(inner: HTMLElement, sizeScroll: number, stopPoints: number[] = [], width?: number): void {
    const offset =
        stopPoints.length > 2 ? getLeftStop(inner.scrollLeft, stopPoints, width) : inner.scrollLeft - sizeScroll;

    scrollInnerTo(inner, offset);
}

export function scrollRight(inner: HTMLElement, sizeScroll: number, stopPoints: number[] = [], width?: number): void {
    const offset =
        stopPoints.length > 2 ? getRightStop(inner.scrollLeft, stopPoints, width) : inner.scrollLeft + sizeScroll;

    scrollInnerTo(inner, offset);
}
